import {
  downloadAnalyticsExport,
  type AnalyticsExportFormat,
  type AnalyticsExportTableSection,
} from "@/components/pages/analytics/front-desk/utils/analyticsFileExport";
import type { PartnerRevenueAnalyticsPeriod } from "@/types/partner-revenue-analytics";
import type { GuesteriaPartnerDetail } from "./guesteriaPartnersModel";

type PartnerDetailExportParams = {
  partner: GuesteriaPartnerDetail;
  hotelId: string;
  period: PartnerRevenueAnalyticsPeriod;
  periodLabel: string;
  connectionStatusLabel: string;
  categoryText: string;
  regionText: string;
  revenueSummary: string;
  commissionText: string;
  currency: string;
  points: Array<{
    label: string;
    totalRevenue: number;
    totalOrders: number;
    currency: string;
  }>;
};

function buildPartnerDetailSections(
  params: PartnerDetailExportParams,
): AnalyticsExportTableSection[] {
  const {
    partner,
    hotelId,
    periodLabel,
    connectionStatusLabel,
    categoryText,
    regionText,

    revenueSummary,
    commissionText,
    currency,
    points,
  } = params;

  return [
    {
      title: "Partner",
      headers: ["Field", "Value"],
      rows: [
        ["Partner", partner.name],
        ["Partner ID", partner.id],
        ["Hotel ID", hotelId],
        ["Period", periodLabel],
        ["Connection Status", connectionStatusLabel],
        ["Category", categoryText],
        ["Region", regionText],
        ["Commission", commissionText],
        ["Revenue (summary)", revenueSummary],
      ],
    },
    {
      title: "Revenue Analytics",
      headers: ["Period", `Revenue (${currency})`, "Orders"],
      rows: points.map((point) => [
        point.label,
        point.totalRevenue,
        point.totalOrders,
      ]),
    },
  ];
}

export function downloadPartnerDetailExport(
  format: AnalyticsExportFormat,
  params: PartnerDetailExportParams,
): void {
  downloadAnalyticsExport(
    format,
    buildPartnerDetailSections(params),
    `partner-${params.partner.id}-${params.period}`,
  );
}
